var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from '../decorators/injectable';
export const name = 'Redirector';
let Redirector = class Redirector {
    static redirect(href) {
        window.location.assign(href);
    }
    static open(href) {
        window.open(href);
    }
    /**
     * When you want to get the behavior of a redirect, but it must be a POST request instead of a GET request.
     * Initial use case was POST redirect to Single Sign On / Link (sso-link) page.
     *
     * @param href Redirect URL
     * @param params Redirect POST params
     */
    static redirectAsPost(href, params) {
        const inputs = new DocumentFragment();
        Object.entries(params).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            inputs.appendChild(input);
        });
        const form = document.createElement('form');
        form.appendChild(inputs);
        form.action = href;
        form.method = 'post';
        document.body.appendChild(form);
        form.submit();
    }
};
Redirector = __decorate([
    injectable(name)
], Redirector);
export default Redirector;
